import request from '@/utils/request'


// 查询加价记录列表
export function listAddPrice(query) {
  return request({
    url: '/addPrice/addPrice/list',
    method: 'get',
    params: query
  })
}

// 查询加价记录分页
export function pageAddPrice(query) {
  return request({
    url: '/addPrice/addPrice/page',
    method: 'get',
    params: query
  })
}

// 查询加价记录详细
export function getAddPrice(data) {
  return request({
    url: '/addPrice/addPrice/detail',
    method: 'get',
    params: data
  })
}

// 新增加价记录
export function addAddPrice(data) {
  return request({
    url: '/addPrice/addPrice/add',
    method: 'post',
    data: data
  })
}

// 修改加价记录
export function updateAddPrice(data) {
  return request({
    url: '/addPrice/addPrice/edit',
    method: 'post',
    data: data
  })
}

// 删除加价记录
export function delAddPrice(data) {
  return request({
    url: '/addPrice/addPrice/delete',
    method: 'post',
    data: data
  })
}
